import React, { useEffect, useState } from "react";
import { Box, Typography, Fade, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const slides = [
  {
    image: "/slider1.png",
    title: "Filtration Excellence Since 1980",
    subtitle: "Engineering solutions for demanding industrial needs.",
  },
  {
    image: "/slider2.png",
    title: "Precision That Performs",
    subtitle: "Designed for safety, efficiency, and reliability.",
  },
  {
    image: "/slider4.jpg",
    title: "Engineered for Tough Environments",
    subtitle: "Pipelines, LNG, and Fertilizers.",
  },
  {
    image: "/slider3.jpg",
    title: "Powering Critical Industries",
    subtitle: "Oil & Gas, Power, Petrochemicals, and Refineries.",
  },
  {
    image: "/slider5.jpg",
    title: "Innovation with Reliability",
    subtitle: "Customized solutions delivering global performance.",
  },
];

export default function HeroSlider() {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  /* ================= AUTO SLIDE ================= */
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  /* ================= HANDLERS ================= */
  const handleNext = () => {
    setFade(false);
    setTimeout(() => {
      setIndex((prev) => (prev + 1) % slides.length);
      setFade(true);
    }, 400);
  };

  const handlePrev = () => {
    setFade(false);
    setTimeout(() => {
      setIndex((prev) => (prev - 1 + slides.length) % slides.length);
      setFade(true);
    }, 400);
  };

  const current = slides[index];

  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: 450, sm: 550, md: 700, lg: 820 },
        overflow: "hidden",
        mt: { xs: "-64px", md: "-75px" },
      }}
    >
      {/* ================= BACKGROUND IMAGE ================= */}
      <Fade in={fade} timeout={700}>
        <Box
          key={current.image}
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${current.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 0,
          }}
        />
      </Fade>

      {/* ================= DARK OVERLAY ================= */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "rgba(3, 3, 3, 0.45)",
          zIndex: 1,
        }}
      />

      {/* ================= LEFT ARROW ================= */}
      <IconButton
        onClick={handlePrev}
        sx={{
          position: "absolute",
          top: "50%",
          left: { xs: 10, md: 30 },
          transform: "translateY(-50%)",
          zIndex: 3,
          color: "#fff",
          background: "rgba(0,0,0,0.4)",
          "&:hover": {
            background: "rgba(0,0,0,0.6)",
          },
        }}
      >
        <ArrowBackIosNewIcon />
      </IconButton>

      {/* ================= RIGHT ARROW ================= */}
      <IconButton
        onClick={handleNext}
        sx={{
          position: "absolute",
          top: "50%",
          right: { xs: 10, md: 30 },
          transform: "translateY(-50%)",
          zIndex: 3,
          color: "#fff",
          background: "rgba(0,0,0,0.4)",
          "&:hover": {
            background: "rgba(0,0,0,0.6)",
          },
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>

      {/* ================= TEXT CONTENT ================= */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          color: "#fff",
          maxWidth: "1600px",
          mx: "auto",
          px: { xs: 3, sm: 5, md: 10, lg: "250px" },
        }}
      >
        <Fade in={fade} timeout={700}>
          <Box>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                mb: 2,
                fontSize: {
                  xs: "1.9rem",
                  sm: "2.4rem",
                  md: "3rem",
                  lg: "3.5rem",
                },
                lineHeight: 1.18,
              }}
            >
              {current.title}
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.2rem", lg: "1.3rem" },
                maxWidth: "700px",
                lineHeight: 1.65,
              }}
            >
              {current.subtitle}
            </Typography>
          </Box>
        </Fade>
      </Box>
    </Box>
  );
}
